import React, {Component} from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import {Helmet} from "react-helmet";

export class PrivacyPT extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Política de privacidade - CamAPS FX</title>
                    <meta name="title" content='Política de privacidade'/>
                    <meta name="description"
                          content='Aqui encontra a política de privacidade da CamDiab'/>
                    <meta property="og:locale" content='pt_PT'/>
                    <meta name="keywords" content='política de privacidade'/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Política de privacidade</h1>
                                <h3>Versão datada de 4 de junho de 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <h2>
                                    1. INTRODUÇÃO
                                </h2>
                                <h3>
                                    1.1. Entidade responsável
                                </h3>
                                <p>
                                    A CamDiab Limited, com sede social registada em 20-22 Wenlock Road, London, N1 7GU,
                                    Reino Unido, constituída e registada em Inglaterra e no País de Gales com o número
                                    de sociedade 11659211 ("CamDiab"), é a entidade responsável declarada nos termos da
                                    legislação em matéria de proteção de dados. A CamDiab decide as finalidades e os
                                    meios de tratamento dos dados pessoais dos nossos utilizadores
                                    ("<strong>Dados do Utilizador</strong>") e, por conseguinte, é responsável pela sua
                                    segurança e pela conformidade com a legislação aplicável.
                                </p>
                                <p>
                                    1.1.2 Enquanto entidade responsável, estamos sujeitos, por exemplo, a requisitos de
                                    informação que pretendemos cumprir no âmbito deste aviso de privacidade.
                                </p>
                                <h3>
                                    1.2. Estrutura e conceito de consentimento
                                </h3>
                                <p>
                                    1.2.1 Este aviso de privacidade informa-o sobre as finalidades e o âmbito do
                                    tratamento dos seus Dados do Utilizador, bem como sobre as transferências de dados e
                                    os seus amplos direitos. Uma vez que a nossa oferta se destina exclusivamente a
                                    pessoas com diabetes, a sua utilização geralmente já fornece informações sobre o seu
                                    estado de saúde. Por conseguinte, apenas tratamos os Dados do Utilizador como dados
                                    de saúde com o seu consentimento. Fazemos a seguinte distinção:
                                </p>
                                <p>
                                    1.2.1.1 "Tratamento Necessário" descreve como tratamos os Dados do Utilizador
                                    necessários para cumprir o contrato. Sem este consentimento, a utilização dos nossos
                                    produtos não é possível do ponto de vista legal e factual, uma vez que os nossos
                                    serviços dependem deste tratamento.
                                </p>
                                <p>
                                    1.2.1.2 "Tratamento para Melhoria do Produto" explica como pode ajudar-nos, a nós e
                                    a outros utilizadores, com o seu consentimento, permitindo-nos utilizar os seus
                                    dados, em particular para melhorar algoritmos de gestão terapêutica, melhorar o
                                    produto, etc., sem que o contactemos.
                                </p>
                                <p>
                                    1.2.1.3 "Tratamento para Fins de Marketing" descreve como o contactamos para fins
                                    de marketing, com o seu consentimento, por exemplo, por e-mail, notificações, etc.,
                                    bem como a forma como podemos tratar conteúdo adicional se aceitar separadamente
                                    participar em casos de estudo, testemunhos, histórias de clientes, participação nos
                                    meios de comunicação ou outras atividades promocionais.
                                </p>
                                <p>
                                    1.2.1.4 Para evitar repetições, reunimos em "Informações gerais" as informações
                                    aplicáveis a todos os consentimentos acima.
                                </p>
                                <p>
                                    As categorias correspondentes são descritas em maior detalhe abaixo. Ao registar-se
                                    ou ao encomendar o seu produto, deve fornecer o consentimento correspondente.
                                </p>
                                <p>
                                    1.2.2 Em determinados casos, o tratamento pode ocorrer independentemente do
                                    consentimento, com base em princípios legais (por exemplo, legislação relativa a
                                    dispositivos médicos).
                                </p>
                                <h2>
                                    2. TRATAMENTO NECESSÁRIO
                                </h2>
                                <p>
                                    Se der o seu consentimento, tratamos os Dados do Utilizador indicados abaixo para
                                    podermos prestar os nossos serviços. Se não consentir este tratamento necessário,
                                    não poderá utilizar os serviços da CamDiab. Pode dar o seu consentimento durante o
                                    processo de registo ou ao encomendar o seu produto.
                                </p>
                                <h3>
                                    2.1. Dados do Utilizador necessários
                                </h3>
                                <p>
                                    2.1.1 Para proteger os seus Dados do Utilizador, os nossos serviços apenas podem ser
                                    utilizados em ligação com uma conta de utilizador. Para criar uma conta de
                                    utilizador, necessitamos e tratamos os seguintes Dados do Utilizador:
                                </p>
                                <ul type="disc">
                                    <li>
                                        Endereço de e-mail
                                    </li>
                                    <li>
                                        Palavra-passe (apenas guardamos uma soma de verificação)
                                    </li>
                                    <li>
                                        Nome
                                    </li>
                                    <li>
                                        Declaração de isenção de IVA (nome, morada, data; para utilizadores que suportam
                                        os próprios custos)
                                    </li>
                                    <li>
                                        Ano de nascimento
                                    </li>
                                    <li>
                                        Data de registo
                                    </li>
                                    <li>
                                        Estado do consentimento
                                    </li>
                                    <li>
                                        ID do dispositivo, fabricante, tipo de dispositivo, versão do sistema
                                        operativo, versão da aplicação
                                    </li>
                                    <li>
                                        Idioma, país, fuso horário.
                                    </li>
                                </ul>
                                <p>
                                    2.1.2 Outros dados recolhidos fora do registo do utilizador incluem:
                                </p>
                                <p>
                                    <strong>Dados médicos principais</strong>
                                    <br/>
                                    Peso, intervalo-alvo de glicemia, definições basais da bomba, fatores de correção,
                                    relação hidratos de carbono/insulina, duração da ação da insulina, glicose-alvo,
                                    definições de alerta, passo de bólus, unidade de hidratos de carbono, estado de
                                    gravidez, data prevista do parto.
                                </p>
                                <p>
                                    <strong>Dados de utilização e ligação</strong>
                                    <br/>
                                    Número de série da bomba e do transmissor, rastreio das ações da bomba, do sensor e
                                    do circuito fechado/aberto, rastreio do fluxo de comandos da aplicação, rastreio de
                                    eventos, informações dos seguidores introduzidas na aplicação (número de telefone,
                                    credenciais de contas de portais de dados de diabetes), pedidos de apoio, dados do
                                    formador, identificação da clínica de diabetes.
                                </p>
                                <p>
                                    <strong>Dados médicos</strong>
                                    <br/>
                                    Entradas na aplicação, tais como data/hora/fuso horário/local, ingestão de
                                    alimentos/refeição, medições de glicose no sangue e no sensor, taxa de variação da
                                    glicose do sensor, dose diária total de insulina, administração de insulina (bólus
                                    e basal), taxa basal temporária, estado de circuito fechado, preparação da bomba e
                                    da cânula, alertas, eventos de boost e ease-off, definições da aplicação, tais como
                                    opções de visualização, resumos estatísticos dos dados de glicose e insulina.
                                </p>
                                <p>
                                    2.1.3 A aplicação pode necessitar de acesso à sua localização exclusivamente para
                                    permitir a conectividade Bluetooth Low Energy (BLE), conforme exigido pelas
                                    permissões do sistema operativo. No entanto, a aplicação não recolhe, armazena nem
                                    partilha quaisquer dados de localização.
                                </p>
                                <p>
                                    2.1.4 Se desejar, pode introduzir qualquer endereço de e-mail que tenha configurado
                                    especialmente para nós. No entanto, este deve funcionar para que possamos enviar-lhe
                                    avisos importantes.
                                </p>
                                <p>
                                    Apenas tratamos os Dados do Utilizador que fornece ativa e voluntariamente à CamDiab
                                    ou que são obtidos a partir do sensor de glicose e da bomba de insulina aos quais se
                                    liga voluntariamente. No entanto, a introdução dos Dados do Utilizador necessários é
                                    indispensável para a utilização integral dos nossos produtos.
                                </p>
                                <h3>
                                    2.2. Finalidades necessárias
                                </h3>
                                <p>
                                    2.2.1 Todas as finalidades necessárias do nosso tratamento estão associadas à
                                    prestação dos nossos serviços:
                                </p>
                                <p>
                                    <strong>A consulta do cliente</strong> leva ao registo de dados de contacto.
                                </p>
                                <p>
                                    <strong>A encomenda das nossas aplicações</strong> por utilizadores que suportam os
                                    próprios custos leva ao registo de dados de contacto e de dados técnicos, como o ID
                                    do dispositivo.
                                </p>
                                <p>
                                    <strong>A instalação das nossas aplicações</strong> leva ao registo de dados técnicos
                                    e relacionados com o dispositivo.
                                </p>
                                <p>
                                    <strong>O registo</strong> leva à criação da sua conta CamDiab utilizando o endereço
                                    de e-mail e a palavra-passe.
                                </p>
                                <p>
                                    A <strong>prestação dos nossos serviços</strong> exige que introduza ou forneça dados
                                    de forma voluntária e ativa, e cada função descreve a finalidade para a qual os
                                    dados são necessários.
                                </p>
                                <p>
                                    Comunicação entre a CamDiab ou o distribuidor e o utilizador nas nossas aplicações
                                    ou através de outros serviços de mensagens eletrónicas (por exemplo, e-mail,
                                    mensagens, telefone), quando tal seja necessário para prestar apoio ou resolver
                                    problemas relacionados com os nossos produtos. É desta forma que tratamos, através
                                    dos vários canais de comunicação, os comentários e pedidos que possa ter ao utilizar
                                    a CamDiab. O exemplo mais importante é o nosso serviço de apoio, que pode contactar
                                    através de support@camdiab.com. Por conseguinte, pense nas informações e nos dados
                                    que pretende fornecer na sua comunicação ativa connosco, uma vez que essa decisão é
                                    exclusivamente sua. Da nossa parte, pode ser necessário comunicar com os
                                    utilizadores por e-mail ou meio semelhante. É assim que o informamos sobre
                                    atualizações dos nossos produtos e lhe fornecemos conselhos de segurança
                                    importantes, bem como assistência relacionada com a sua utilização. Esta comunicação
                                    de apoio é enviada aos utilizadores como parte essencial dos nossos produtos.
                                </p>
                                <p>
                                    <strong>Os dispositivos terapêuticos</strong> (por exemplo, sensor de glicose e
                                    bombas de insulina) são emparelhados com o seu dispositivo, permitindo a
                                    transferência de dados para as nossas aplicações.
                                </p>
                                <p>
                                    <strong>Os portais de dados de diabetes e a partilha de dados</strong>, como os da
                                    mylife Cloud/Glooko, permitem a troca de dados com as nossas aplicações. No entanto,
                                    a sincronização só ocorre se a ativar nas definições das nossas aplicações, isto é,
                                    se utilizar a função. O aviso de privacidade dos fabricantes de portais de dados de
                                    diabetes aplica-se aos dados partilhados com esses colaboradores terceiros.
                                </p>
                                <p>
                                    2.2.2 A <strong>utilização</strong> das nossas aplicações exige que introduza ou
                                    forneça dados de forma ativa e voluntária. Para resolver um erro na aplicação,
                                    necessitamos, por exemplo, de relatórios de falha que possamos utilizar para
                                    resolução de problemas e para determinar as circunstâncias em que estes ocorreram.
                                    Além disso, são registados os dados-chave do seu dispositivo e o seu comportamento
                                    de utilização, uma vez que o nosso cumprimento contratual implica, sobretudo, a
                                    personalização dos nossos produtos, ou seja, o tratamento de informações individuais
                                    do utilizador, por exemplo, em função da sua localização (também relevante para a
                                    função de pesquisa). A análise automatizada do comportamento do utilizador tem como
                                    único objetivo personalizar a sua utilização no cumprimento do contrato e não produz
                                    qualquer efeito legal para si.
                                </p>

                                <h2>
                                    3. TRATAMENTO PARA MELHORIA DO PRODUTO
                                </h2>
                                <p>
                                    Também tratamos os seus Dados do Utilizador para além da utilização necessária
                                    descrita na secção 2 acima, a fim de melhorar os nossos produtos e serviços,
                                    conforme descrito em maior detalhe abaixo.
                                </p>
                                <h3>
                                    3.1. Dados adicionais
                                </h3>
                                <p>
                                    Em geral, utilizamos os mesmos Dados do Utilizador para melhorar os nossos produtos,
                                    conforme indicado na secção 2. Além disso, a CamDiab também pode registar os
                                    seguintes Dados do Utilizador:
                                </p>
                                <p>
                                    <strong>Dados de utilização</strong>
                                    <br/>
                                    Eventos de atividade que nos permitem compreender como utiliza os nossos produtos.
                                    Estes permitem-nos ver a forma como os nossos produtos são utilizados e, por
                                    exemplo, onde podemos otimizar a conceção dos menus.
                                </p>
                                <h3>
                                    3.2. Objetivo da melhoria do produto
                                </h3>
                                <p>
                                    Os rápidos avanços tecnológicos obrigam-nos a analisar, desenvolver, testar e
                                    melhorar continuamente os produtos e as suas interações. Esta é a forma de garantir
                                    que os nossos conteúdos beneficiam os utilizadores da forma mais eficaz. Para tal,
                                    podemos realizar avaliações de utilização, viabilidade, previsão, controlo e
                                    segurança. Os conhecimentos adquiridos são incorporados em novas versões melhoradas
                                    dos nossos produtos, como a aplicação. Estas melhorias também lhe são disponibilizadas
                                    através de atualizações regulares.
                                </p>
                                <p>
                                    A CamDiab está empenhada na ciência de todos os aspetos da diabetes. Por conseguinte,
                                    os Dados do Utilizador anónimos também podem ser utilizados para fins de
                                    investigação e estatística (respeitando sempre as normas éticas científicas
                                    reconhecidas) e análises internas. Isto pode incluir a partilha de dados
                                    anonimizados com colaboradores terceiros.
                                </p>

                                <h2>
                                    4. TRATAMENTO PARA FINS DE MARKETING
                                </h2>
                                <h3>
                                    4.1. Boletim informativo
                                </h3>
                                <p>
                                    4.1.1 Podemos enviar-lhe informações sobre produtos e serviços, para além dos
                                    serviços contratuais (incluindo informações de parceiros cuidadosamente
                                    selecionados), bem como convites para participar em inquéritos ou noutras promoções
                                    de vendas e atividades de marketing ("<strong>Boletim informativo</strong>").
                                </p>
                                <p>
                                    4.1.2 Pode escolher se pretende subscrever o nosso boletim informativo (opt-in).
                                    Pode revogar o seu consentimento a qualquer momento nas definições da conta.
                                </p>
                                <h3>
                                    4.2. Outros tipos de marketing
                                </h3>
                                <p>
                                    4.2.1 Quando necessário, serão obtidos outros consentimentos, por exemplo, para
                                    inquéritos, notificações ou ofertas personalizadas. Explicamos-lhe sempre por que
                                    motivo necessitamos de determinados dados e também como pode revogar o consentimento.
                                </p>
                                <p>
                                    4.2.2 Tenha em atenção que podemos apresentar-lhe ofertas dentro da aplicação sem
                                    tratar os seus dados pessoais. Também verá estes anúncios não personalizados se não
                                    tiver dado o seu consentimento.
                                </p>
                                <h3>
                                    4.3. Casos de estudo, testemunhos e participação nos meios de comunicação
                                </h3>
                                <p>
                                    4.3.1 Com o seu consentimento explícito, a CamDiab pode tratar dados pessoais
                                    adicionais quando decidir participar em entrevistas, casos de estudo, testemunhos
                                    escritos, histórias de clientes, participação nos meios de comunicação ou outras
                                    atividades promocionais.
                                </p>
                                <p>
                                    4.3.2 Em função da sua participação voluntária, o Conteúdo do Caso de Estudo pode
                                    incluir:
                                </p>
                                <ul type="disc">
                                    <li>
                                        respostas escritas a entrevistas ou testemunhos;
                                    </li>
                                    <li>
                                        fotografias ou imagens estáticas suas;
                                    </li>
                                    <li>
                                        imagens de estilo de vida que forneça;
                                    </li>
                                    <li>
                                        gravações de vídeo ou áudio, quando decidir fornecê-las;
                                    </li>
                                    <li>
                                        o seu nome, grupo etário e informações biográficas;
                                    </li>
                                    <li>
                                        detalhes sobre a sua experiência de viver com diabetes tipo 1;
                                    </li>
                                    <li>
                                        informações sobre a sua utilização do CamAPS FX; e
                                    </li>
                                    <li>
                                        dados adicionais pertencentes a categorias especiais, incluindo dados de saúde,
                                        que decida partilhar.
                                    </li>
                                </ul>
                                <p>
                                    4.3.3 O Conteúdo do Caso de Estudo é tratado exclusivamente para fins de marketing e
                                    comunicação, incluindo a publicação no nosso site, canais de redes sociais, materiais
                                    impressos, marketing digital, comunicações de imprensa ou meios de comunicação e
                                    apresentações.
                                </p>
                                <p>
                                    4.3.4 A participação é voluntária e não é necessária para utilizar os nossos
                                    produtos. Pode retirar o seu consentimento a qualquer momento contactando
                                    privacy@camdiab.com. A retirada não afeta a licitude do tratamento realizado antes
                                    da retirada, nem as publicações já realizadas antes da retirada.
                                </p>
                                <h2>
                                    5. UTILIZAÇÃO PARA FINS LEGAIS
                                </h2>
                                <h3>
                                    5.1. Investigação científica e estatística
                                </h3>
                                <p>
                                    A CamDiab está empenhada na ciência de todos os aspetos da diabetes. Por conseguinte,
                                    os Dados do Utilizador anónimos também podem ser utilizados para fins de
                                    investigação e estatística (respeitando sempre as normas éticas científicas
                                    reconhecidas) e análises internas. São utilizados principalmente para determinar e
                                    melhorar a eficácia das técnicas de controlo e tratamento da diabetes. A base legal
                                    correspondente é o Artigo 9.º, n.º 2, alínea j), do RGPD.
                                </p>
                                <h3>
                                    5.2. Execução de direitos
                                </h3>
                                <p>
                                    A utilização de dados pessoais também pode ser necessária para evitar utilizações
                                    indevidas por parte dos utilizadores ou para fazer valer, exercer ou defender direitos
                                    legais. Podemos ser obrigados a divulgar informações devido a leis vinculativas,
                                    decisões e instruções judiciais ou oficiais, investigações criminais ou por razões de
                                    interesse público. Nestes casos, a lei permite conservar e tratar os seus dados sem
                                    o seu consentimento. A base legal correspondente é o Artigo 9.º, n.º 2, alínea f),
                                    do RGPD.
                                </p>
                                <h3>
                                    5.3. De acordo com a legislação relativa a dispositivos médicos
                                </h3>
                                <p>
                                    Por último, enquanto fabricante ou distribuidor de um dispositivo médico, estamos
                                    sujeitos a um maior número de requisitos de controlo da funcionalidade do nosso
                                    produto. Este sistema de vigilância exigido para fins regulamentares também pode
                                    implicar o tratamento de dados pessoais. Os dados pessoais tratados para a
                                    monitorização da segurança e do desempenho serão conservados durante um período mais
                                    longo, a fim de permitir a monitorização da segurança e a investigação de
                                    acontecimentos adversos, o que exige que os dados continuem identificáveis. A base
                                    legal correspondente é o Artigo 9.º, n.º 2, alínea i), do RGPD.
                                </p>
                                <h2>
                                    6. INFORMAÇÕES GERAIS
                                </h2>
                                <h3>
                                    6.1. Limitação da finalidade e segurança
                                </h3>
                                <p>
                                    6.1.1 A CamDiab utiliza os seus dados pessoais exclusivamente para as finalidades
                                    determinadas neste aviso de privacidade e nos consentimentos correspondentes.
                                    Asseguramos que nenhum tratamento ultrapassa a finalidade correspondente.
                                </p>
                                <p>
                                    6.1.2 Cada tratamento garante sempre a segurança e a confidencialidade adequadas dos
                                    seus dados pessoais. Esta cláusula abrange a proteção contra o tratamento não
                                    autorizado e ilegal, a perda não intencional e a destruição ou dano não intencionais,
                                    através de medidas técnicas e organizativas apropriadas. Utilizamos processos
                                    internos, elementos de segurança e métodos de encriptação rigorosos.
                                </p>
                                <h3>
                                    6.2. Subcontratantes
                                </h3>
                                <p>
                                    6.2.1 Os nossos produtos estão sujeitos a processos complexos que temos de gerir e
                                    manter atualizados. Para assistência técnica, podemos recorrer a fornecedores
                                    externos ("<strong>Subcontratantes</strong>"), a fim de lhe oferecer uma utilização
                                    completa e ótima dos nossos produtos.
                                </p>
                                <p>
                                    6.2.2 A CamDiab transfere os Dados do Utilizador para os Subcontratantes
                                    exclusivamente no âmbito deste aviso de privacidade e apenas para cumprir as
                                    finalidades nele especificadas. Os Subcontratantes trabalham de acordo com as
                                    nossas especificações e instruções; não estão autorizados a utilizar os dados
                                    pessoais dos nossos utilizadores para fins próprios ou de terceiros.
                                </p>
                                <p>
                                    6.2.3 Recorremos a Subcontratantes que oferecem garantias suficientes de adoção das
                                    medidas técnicas e organizativas adequadas para que o tratamento dos dados pessoais
                                    cumpra os requisitos legais e o nosso aviso de privacidade. A proteção dos direitos
                                    dos nossos utilizadores é garantida através da celebração de contratos vinculativos
                                    que cumprem os requisitos rigorosos do RGPD.
                                </p>
                                <h3>
                                    6.3. Encriptação, pseudonimização e anonimização
                                </h3>
                                <p>
                                    6.3.1 Cada transferência de dados, sem exceção e por defeito, é encriptada durante a
                                    transferência. Através da utilização de HTTPS (protocolo seguro de transferência de
                                    hipertexto) ou semelhante, asseguramos que terceiros não autorizados não intercetam
                                    os seus dados.
                                </p>
                                <p>
                                    Além disso, para efeitos de segurança e minimização dos dados, também utilizamos
                                    outros processos para a encriptação e pseudonimização dos Dados do Utilizador.
                                    Naturalmente, isto depende do tipo, âmbito e finalidade do tratamento de dados
                                    correspondente. Por exemplo, apenas divulgamos os Dados do Utilizador de que um
                                    Subcontratante necessita para executar as suas tarefas.
                                </p>
                                <p>
                                    6.3.2 Ao terminar uma relação contratual com um Subcontratante, esse Subcontratante
                                    deve, a critério da CamDiab, devolver todos os nossos Dados do Utilizador ou
                                    eliminá-los se não existirem obrigações legais de conservação.
                                </p>
                                <p>
                                    6.3.3 Os dados que não requerem referências pessoais para o seu tratamento (por
                                    exemplo, para investigação e análise) são anonimizados. Desta forma, evita-se
                                    associá-los a um utilizador concreto em todos os casos.
                                </p>
                                <h3>
                                    6.4. UE e outros países
                                </h3>
                                <p>
                                    6.4.1 Pretendemos selecionar parceiros de colaboração que tenham sede ou cujos
                                    servidores estejam situados na União Europeia (UE) ou no Espaço Económico Europeu
                                    (EEE). A transmissão de dados no seio da UE e do EEE é inquestionável, uma vez que o
                                    RGPD se aplica em todos os Estados-Membros.
                                </p>
                                <p>
                                    6.4.2 Em circunstâncias excecionais, designamos fornecedores externos que estão
                                    localizados ou têm servidores fora da UE. No entanto, mesmo nestes casos, os seus
                                    dados pessoais estão sujeitos a um elevado nível de proteção em conformidade com o
                                    RGPD — seja através de uma decisão de adequação da UE, que considera adequada a
                                    proteção de dados em determinados países terceiros (por exemplo, Suíça, Israel e Nova
                                    Zelândia), seja através de determinadas cláusulas contratuais-tipo aprovadas pela
                                    UE, nas quais se baseiam as relações contratuais com os nossos subcontratantes de
                                    dados contratados, ou através de instrumentos legais comparáveis permitidos pelo
                                    RGPD.
                                </p>
                                <p>
                                    6.4.3 Além disso, asseguramos que os nossos parceiros dispõem de normas de segurança
                                    adicionais, tais como medidas de segurança individuais e disposições de proteção de
                                    dados ou certificações ao abrigo do RGPD. Assim, por exemplo, se os fornecedores
                                    externos estiverem localizados nos EUA, deverão estar sujeitos ao enquadramento do
                                    Escudo de Proteção da Privacidade aprovado pela UE ou a normas de segurança
                                    comparáveis reconhecidas internacionalmente.
                                </p>
                                <h3>
                                    6.5. Cookies
                                </h3>
                                <p>
                                    A CamDiab pode armazenar os chamados "cookies" para lhe oferecer uma ampla gama de
                                    funcionalidades e tornar a navegação no nosso site mais prática. Os cookies são
                                    pequenos ficheiros de texto que o navegador armazena no seu dispositivo. Com exceção
                                    dos cookies para dados de utilização mencionados na secção 6.6, os nossos cookies
                                    podem ser utilizados para o funcionamento do site. Se não pretender utilizar
                                    cookies, pode impedir que sejam guardados através da configuração correspondente do
                                    navegador. A maioria dos nossos cookies é eliminada no final da visita ou ao fechar o
                                    navegador (cookies de sessão). Caso contrário, pode verificar o período de
                                    eliminação no seu navegador ou eliminar os cookies manualmente.
                                </p>
                                <h3>
                                    6.6. Dados de utilização
                                </h3>
                                <p>
                                    Na aplicação, utilizamos o Google Firebase Analytics, um serviço de análise de
                                    aplicações e Web da Google Inc. ("Google"). A Google possui certificação ao abrigo
                                    do Escudo de Proteção da Privacidade UE-EUA.
                                </p>
                                <h3>
                                    6.7. Armazenamento e eliminação
                                </h3>
                                <p>
                                    6.7.1 Os seus Dados do Utilizador são armazenados no seu dispositivo. Estes dados
                                    também são armazenados em servidores. Utilizamos apenas sistemas que cumprem os
                                    requisitos do RGPD.
                                </p>
                                <p>
                                    6.7.2 Os seus dados são armazenados em servidores na União Europeia (UE).
                                </p>
                                <p>
                                    6.7.3 Regra geral, a CamDiab apenas armazena os seus dados pessoais durante a
                                    vigência do contrato. Em casos excecionais, pode ser necessário um armazenamento mais
                                    prolongado para cumprir obrigações pós-contratuais, obrigações legais de
                                    armazenamento ou deveres de divulgação, ou ainda para fazer valer, exercer ou
                                    defender reclamações legais (prazos de prescrição).
                                </p>
                                <p>
                                    6.7.4 Conservação de materiais de casos de estudo
                                    <br/>
                                    O Conteúdo do Caso de Estudo para o qual tenha dado o seu consentimento poderá ser
                                    conservado até retirar esse consentimento, sujeito a qualquer período mais curto
                                    indicado no formulário de consentimento correspondente. Após a retirada do
                                    consentimento, deixaremos de utilizar os seus materiais para novas publicações. O
                                    conteúdo já publicado antes da retirada pode continuar a existir em espaços públicos
                                    fora do controlo da CamDiab.
                                </p>
                                <h3>
                                    6.8. Menores
                                </h3>
                                <p>
                                    Os menores de dezasseis anos apenas podem utilizar os nossos produtos com o
                                    consentimento de um progenitor/tutor (<a href="/pt/terms">Condições Gerais -
                                    CG</a>). Isto também se aplica ao tratamento dos seus dados pessoais, que só será
                                    legal na medida em que o consentimento tenha sido obtido por intermédio do
                                    progenitor/tutor. Caso contrário, a utilização dos nossos produtos é proibida.
                                </p>
                                <p>
                                    Se um menor participar no Conteúdo do Caso de Estudo, o consentimento deve ser dado
                                    pelo progenitor ou tutor legal do menor. Não recolhemos nem publicamos Conteúdo do
                                    Caso de Estudo relativo a menores sem o consentimento verificado de um progenitor ou
                                    tutor legal.
                                </p>
                                <h3>
                                    6.9. Encarregado da proteção de dados
                                </h3>
                                <p>
                                    6.9.1 O nosso encarregado da proteção de dados está à sua disposição para responder
                                    a todas as perguntas sobre proteção de dados em dpo@evalian.co.uk.
                                </p>
                                <p>
                                    6.9.2 O encarregado da proteção de dados intervém regularmente em todas as questões
                                    relacionadas com a proteção dos dados pessoais dos nossos utilizadores. Enquanto
                                    especialista formado, supervisiona continuamente o nosso tratamento para garantir a
                                    melhor proteção possível dos seus Dados do Utilizador.
                                </p>
                                <h3>
                                    6.10. Partilha do Conteúdo do Caso de Estudo com terceiros
                                </h3>
                                <p>
                                    6.10.1 Com o seu consentimento, podemos partilhar o Conteúdo do Caso de Estudo com
                                    parceiros de relações públicas cuidadosamente selecionados, com a finalidade de
                                    preparar, editar e publicar casos de estudo ou materiais promocionais relacionados
                                    em nosso nome.
                                </p>
                                <p>
                                    6.10.2 Se também tiver dado o seu consentimento para participar em imprensa ou meios
                                    de comunicação, o Conteúdo do Caso de Estudo pode ser partilhado com jornalistas,
                                    publicações ou meios de comunicação social. Não vendemos os seus dados e apenas
                                    partilhamos o que for necessário para a finalidade de marketing ou comunicação
                                    prevista.
                                </p>
                                <h2>
                                    7. OS SEUS DIREITOS
                                </h2>
                                <h3>
                                    7.1. Revogação dos consentimentos
                                </h3>
                                <p>
                                    Se tratarmos os seus Dados do Utilizador com base no seu consentimento, pode revogar
                                    esse consentimento a qualquer momento. No entanto, esta ação não afetará a legalidade
                                    do tratamento antes da revogação. Continuaremos a prestar os nossos serviços se estes
                                    não dependerem do consentimento revogado.
                                </p>
                                <p>
                                    Se retirar o seu consentimento relativo ao Conteúdo do Caso de Estudo, a CamDiab
                                    eliminará todos os materiais não publicados e deixará de utilizar o conteúdo para
                                    futuros fins de marketing ou comunicação. É possível que o conteúdo publicado
                                    anteriormente, como cobertura de imprensa, materiais impressos ou publicações
                                    públicas nas redes sociais, não possa ser totalmente retirado.
                                </p>
                                <h3>
                                    7.2. <strong>Informação, correção e limitação</strong>
                                </h3>
                                <p>
                                    7.2.1 Todos os utilizadores têm o direito de solicitar informações sobre o
                                    tratamento dos seus dados pessoais. Para o fazer, contacte-nos a qualquer momento
                                    através de privacy@camdiab.com.
                                </p>
                                <p>
                                    7.2.2 O seu direito à informação abrange informações sobre as finalidades do
                                    tratamento, as categorias de dados e de destinatários, o período de armazenamento, a
                                    origem dos seus dados e os seus direitos ao abrigo da legislação de proteção de
                                    dados. Encontrará todas estas informações neste aviso de privacidade e teremos todo o
                                    gosto em fornecê-las em formato eletrónico.
                                </p>
                                <p>
                                    7.2.3 Se algum dos seus dados pessoais estiver incorreto, pode solicitar a sua
                                    correção ou complemento a qualquer momento. Tem o direito de limitar o tratamento de
                                    dados enquanto durar a revisão de investigação que solicitou.
                                </p>
                                <h3>
                                    7.3. Eliminação ("direito ao apagamento")
                                </h3>
                                <p>
                                    Todos os utilizadores têm o direito de solicitar a eliminação dos seus dados
                                    pessoais. Se assim o desejar, contacte-nos a qualquer momento através de
                                    support@camdiab.com.
                                </p>
                                <h3>
                                    7.4. Reclamações
                                </h3>
                                <p>
                                    7.4.1 Se considerar que não estamos a proteger adequadamente os seus direitos de
                                    proteção de dados, contacte-nos a qualquer momento através de privacy@camdiab.com ou
                                    contacte o encarregado da proteção de dados, através do endereço dpo@evalian.co.uk.
                                    Trataremos o seu pedido devidamente.
                                </p>
                                <p>
                                    7.4.2 Todos os utilizadores têm o direito de apresentar uma reclamação junto da
                                    autoridade de proteção de dados responsável pela CamDiab se considerarem que o
                                    tratamento dos seus dados pessoais não está em conformidade com a legislação de
                                    proteção de dados. Além disso, o utilizador tem o direito de apresentar reclamação
                                    junto de uma autoridade de controlo do Estado-Membro da UE onde resida, onde se
                                    situe o seu local de trabalho ou onde ocorra uma alegada infração.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
